import { Divider, Group, Tooltip } from "@mantine/core";
import classes from "./AuthNav.module.css";
import { NavLink } from "@/components/navigation";
import { useFilteredNavigationItems } from "@/hooks/useFilteredNavigationItems";

/**
 * AuthNav - Navigation component for authenticated users.
 * Displays icon-based navigation items in the header with tooltips and dividers.
 * Only visible on desktop (handled by parent Header component).
 */
export function AuthNav() {
  const filteredNavItems = useFilteredNavigationItems();

  return (
    <Group wrap="nowrap" className={classes.headerNav}>
      {filteredNavItems.map(({ icon, link, label }, index) => (
        <Group key={label} wrap="nowrap">
          <Tooltip label={label} position="bottom">
            <div>
              <NavLink to={link} aria-label={label}>
                {icon}
              </NavLink>
            </div>
          </Tooltip>
          {index < filteredNavItems.length - 1 && (
            <Divider orientation="vertical" data-testid={"divider"} />
          )}
        </Group>
      ))}
    </Group>
  );
}
